import api from './axios';
import { ApiResponse, Product, Category } from '../types';

export const productsAPI = {
  getAll: async (params?: {
    page?: number;
    limit?: number;
    category?: string;
    search?: string;
    min_price?: number;
    max_price?: number;
    is_featured?: boolean;
    sort_by?: string;
    sort_order?: string;
  }) => {
    const res = await api.get<ApiResponse<any>>('/api/products', { params });
    return res.data;
  },

  getOne: async (slug: string) => {
    const res = await api.get<ApiResponse<Product>>(`/api/products/${slug}`);
    return res.data;
  },

  getFeatured: async () => {
    const res = await api.get<ApiResponse<Product[]>>('/api/products/featured');
    return res.data;
  },

  search: async (query: string, page?: number) => {
    const res = await api.get<ApiResponse<Product[]>>('/api/products/search', {
      params: { search: query, page },
    });
    return res.data;
  },

  create: async (data: any) => {
    const res = await api.post<ApiResponse<{ id: string }>>('/api/products', data);
    return res.data;
  },

  update: async (id: string, data: any) => {
    const res = await api.put<ApiResponse<{ id: string }>>(`/api/products/${id}`, data);
    return res.data;
  },

  delete: async (id: string) => {
    const res = await api.delete<ApiResponse<{}>>(`/api/products/${id}`);
    return res.data;
  },

  // Categories
  getCategories: async () => {
    const res = await api.get<ApiResponse<Category[]>>('/api/categories');
    return res.data;
  },

  getCategory: async (slug: string) => {
    const res = await api.get<ApiResponse<Category>>(`/api/categories/${slug}`);
    return res.data;
  },

  createCategory: async (data: any) => {
    const res = await api.post<ApiResponse<Category>>('/api/categories', data);
    return res.data;
  },

  updateCategory: async (id: string, data: any) => {
    const res = await api.put<ApiResponse<Category>>(`/api/categories/${id}`, data);
    return res.data;
  },

  deleteCategory: async (id: string) => {
    const res = await api.delete<ApiResponse<{}>>(`/api/categories/${id}`);
    return res.data;
  },
};